import {enumType} from 'common/enumType';
import * as yup from 'common/yup';

export type KeyPairTypeUnion = keyof typeof KeyPairType.enum;

export const KeyPairType = enumType({
   DSA: 'DH/DSS',
   RSA: 'RSA',
   ECDH: 'ECDH',
   ECDSA: 'ECDSA',
   EDDSA: 'EDDSA',
});

export const KeyPairTypeCreatable = enumType({
   DSA: 'DH/DSS',
   RSA: 'RSA',
   ECDH: 'ECDH',
   // ECDSA: 'ECDSA',
   // EDDSA: 'EDDSA',
});

export const SSHKeyPairType = enumType({
   DSS: 'DSS',
   RSA: 'RSA',
   ECDSA: 'ECDSA',
   EDDSA: 'EDDSA',
});

export const SSHKeyPairTypeCreatable = enumType({
   DSS: 'DSS',
   RSA: 'RSA',
   ECDSA: 'ECDSA',
});

export const KeyPairTypeSchema = yup.string().oneOf(KeyPairType.keys);
export const SSHKeyPairTypeSchema = yup.string().oneOf(SSHKeyPairType.keys);
